import React from 'react';
import { Controller } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Select from "react-select";
import dayjs from 'dayjs';
import DepartmentTreeSelect from '../../list-department/components/department-tree-select';
import DepartmentHelper from '../../list-department/helper/department-helper';
import { FormSearchFunctionButtons } from '../../../components/form-search-wrapper-sarang/form-search-wrapper-sarang';
import { optionsCuisineOrderStatus, optionsReceiptTime } from '../../../common/constant';

const CuisineOrderSearch = ({
    register,
    handleSubmit,
    onSubmit,
    setValue,
    control,
    branch,
    departmentAll,
    herdsmanAll,
    district,
    setSelectedDistrict,
    openAddDialog,
    now
}) => {
    return (
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <div className="row">
                <div className="form-group col-6 col-md-4 col-lg-4 col-xl-4">
                    <label>Từ ngày</label>
                    <DatePicker
                        {...register("orderFromDate")}
                        onChange={(data) => setValue("orderFromDate", data ? dayjs(data).format("YYYY-MM-DD") : null)}
                        defaultValue={dayjs(now)}
                        className="form-control"
                        format='DD/MM/YYYY'
                        slotProps={{ textField: { size: 'small' } }}
                    />
                </div>

                <div className="form-group col-6 col-md-4 col-lg-4 col-xl-4">
                    <label>Đến ngày</label>
                    <DatePicker
                        {...register("orderToDate")}
                        onChange={(data) => setValue("orderToDate", data ? dayjs(data).format("YYYY-MM-DD") : null)}
                        className="form-control"
                        format='DD/MM/YYYY'
                        slotProps={{ textField: { size: 'small' } }}
                    />
                </div>
                <div className="form-group col-md-4">
                    <label>Thời gian</label>
                    <Select
                        {...register("receiptTime", {})}
                        placeholder="Thời gian nhận"
                        closeMenuOnSelect={true}
                        onChange={(data) => setValue("receiptTime", data ? data.value : null)}
                        options={optionsReceiptTime}
                        isClearable
                        noOptionsMessage={() => "Không tồn tại"}
                    />
                </div>
            </div>
            <div className="row">
                <div className="form-group col-md-4">
                    <label>Chi hội</label>
                    <Controller
                        name="branchId"
                        control={control}
                        render={({ onChange, value }) => (
                            <Select
                                isClearable
                                value={branch?.map(item => ({ label: item.name, value: item.id })).find(x => x.value === value) || null}
                                onChange={(data) => onChange(data ? data.value : null)}
                                placeholder="Chọn Chi hội"
                                options={branch?.map(item => ({ label: item.name, value: item.id }))}
                                noOptionsMessage={() => "Không tồn tại"}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        )}
                    />
                </div>
                <div className="form-group col-md-4">
                    <label htmlFor="input-department-general">Ban/Đội/Nhóm</label>
                    <DepartmentTreeSelect
                        {...register("departmentId", {})}
                        onChange={(data) => setValue("departmentId", data ? data.value : null)}
                        placeholder="Chọn Ban"
                        options={DepartmentHelper.RenderOptions(departmentAll)}
                        menuPortalTarget={document.body}
                    />
                </div>
                <div className="form-group col-md-4">
                    <label htmlFor="input-department-general">Ace Swat</label>
                    <Select
                        isClearable
                        {...register("herdsmanId", {})}
                        placeholder="Ace Swat"
                        onChange={(data) => setValue("herdsmanId", data ? data.value : null)}
                        options={(herdsmanAll || []).map(item => { return { label: item?.name, value: item?.id } })}
                        noOptionsMessage={() => "Không tồn tại"}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </div>
            </div>
            <div className="row">
                <div className="form-group col-md-4">
                    <label htmlFor="input-department-general">Trạng thái</label>
                    <Select
                        isClearable
                        placeholder="Trạng thái"
                        {...register("status", {})}
                        onChange={(data) => {
                            setValue("status", data ? data.value : null);
                        }}
                        options={optionsCuisineOrderStatus}
                        noOptionsMessage={() => "Không tồn tại"}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </div>
                <div className="form-group col-md-4">
                    <label htmlFor="input-department-general">Quận/huyện</label>
                    <Select
                        isClearable
                        {...register("districtId", {})}
                        placeholder="Chọn quận/huyện"
                        onChange={(data) => {
                            setValue("districtId", data ? data.value : null);
                            setSelectedDistrict(data || null);
                        }}
                        options={(district || []).map(item => { return { label: item?.name, value: item?.id } })}
                        noOptionsMessage={() => "Không tồn tại"}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </div>
                <div className="form-group col-md-4">
                    <label htmlFor="input-address" className="col-form-label">Địa chỉ</label>
                    <input
                        id="address"
                        className="form-control"
                        type="text"
                        name="address"
                        placeholder="Địa chỉ"
                        ref={register()}
                    />
                </div>
            </div>
            <FormSearchFunctionButtons>
                <div className="row">
                    <div className="col-sm-12 pl-0">
                        <p className="text-center">
                            <button type="submit" className="btn btn-space btn-primary">Tìm kiếm</button>
                            <button className="btn btn-space btn-secondary" type="button">Xóa lọc</button>
                            <button
                                className="btn btn-space btn-warning"
                                onClick={(e) => {
                                    e.preventDefault();
                                    openAddDialog();
                                }}
                            >Thêm mới</button>
                        </p>
                    </div>
                </div>
            </FormSearchFunctionButtons>
        </form>
    );
};

export default CuisineOrderSearch;
